import { Header, Segment, Image as SemanticUiImage } from 'semantic-ui-react';
import FixedElementOnScroll from '../../../../../components/fixedElementOnScroll';
import { ROLES } from '../../../../../constnats/user';
import AuthService from '../../../../../service/auth';
import { getPeriod, getYearsComponent } from '../../../../../utils/reportResourceUtil';
import { useRowsBoundingBoxes } from '../../stores/boundingBoxesStore';
import { useImageStoreHighlightedCoordinates, useImageStoreImage } from '../../stores/imageStore';
import { useRowsImportCandidates } from '../../stores/metadataStore';
import { Coordinate, S3KeyType } from '../../types';
import ImageHighlighter from '../imageHighlighter';
import './resource.styles.css';
import { HIGHLIGHTER_VARIANT } from '../../constants/generalConstants';
import Zoom, { ZoomableContainer } from '../zoom';
import SimpleBar from 'simplebar-react';

type ResourceProps = {
    s3Key: S3KeyType;
    overflowing?: boolean;
};

function Resource({ s3Key, overflowing = false }: ResourceProps) {
    const image = useImageStoreImage();
    const coordinates = useImageStoreHighlightedCoordinates();
    const rowsImportCandidates = useRowsImportCandidates();
    const rowsBoundingBoxes = useRowsBoundingBoxes(rowsImportCandidates);
    const selectedCoordinates = coordinates.map((c) => ({
        top: c.top ?? 0,
        left: c.left ?? 0,
        width: c.width ?? 0,
        height: c.height ?? 0,
        variant: c.variant,
    }));
    const rowsImportCandidatesCoordinates: Coordinate[] = rowsBoundingBoxes
        .filter((box) => {
            return !selectedCoordinates.some(
                (x) => x.top.toFixed(2) === box.top.toFixed(2) && x.left.toFixed(2) === box.left.toFixed(2)
            );
        })
        .map((box) => ({ ...box, variant: HIGHLIGHTER_VARIANT.TERTIARY }));

    const highlightedCoordinates: Coordinate[] = [...selectedCoordinates, ...rowsImportCandidatesCoordinates];
    return (
        <div className="full-height flex flex-column resource">
            <Header as="h3">Resource</Header>
            <div>
                <p>
                    {getYearsComponent(s3Key)} <b>Period: </b>
                    {getPeriod(s3Key)}
                </p>
                {AuthService.hasGlobalRole(ROLES.ADMIN) && (
                    <>
                        <b>Full Path: </b>
                        {s3Key}
                        <br />
                    </>
                )}
            </div>
            <div className="flex-grow-1">
                <FixedElementOnScroll>
                    <Zoom>
                        <Zoom.Container>
                            <Zoom.Controls className="zoom-controls" />
                            <Segment>
                                <SimpleBar autoHide={false}>
                                    <div>
                                        <Zoom.Content>
                                            <ImageHighlighter coordinates={highlightedCoordinates}>
                                                {image && <SemanticUiImage src={image.src} fluid />}
                                            </ImageHighlighter>
                                        </Zoom.Content>
                                    </div>
                                </SimpleBar>
                            </Segment>
                        </Zoom.Container>
                    </Zoom>
                </FixedElementOnScroll>
            </div>
        </div>
    );
}

export default Resource;
